import { useUser } from "@components/user-context";
import { ChangeFractionDisplay } from "@features/sales-v3/table/components/data-type-formatters/change-fraction-display";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { formatting } from "@north-beam/nb-common";

import { type MetricRow } from "../types";

interface Props {
  row: MetricRow;
  metric: SalesMetricV2;
}

export const MetricCell = ({ row, metric }: Props) => {
  const { user } = useUser();

  const actualValue = metric.getValue(row.actualMetrics) ?? 0;
  const compareValue = metric.getValue(row.comparisonMetrics ?? {}) ?? NaN;
  const changeFraction = (actualValue - compareValue) / compareValue;

  // const row = _row as SalesTableVisualRow;
  // const columnDef = column as ColumnDef;
  // const isBenchmark = columnDef.metric?.metadata?.isBenchmark;
  // const isPositiveChangeGood = columnDef.metric?.isPositiveChangeGood;
  // const fractionChange = row?.changeFractions?.[columnDef.id];
  // const benchmark = row?.benchmarks?.[columnDef.id];

  // const canShowMiniGraph =
  //   columnDef.showMiniGraph && !isBenchmark && !columnDef.loading;

  // const {
  //   attributionModel,
  //   attributionWindow,
  //   accountingMode,
  //   filters,
  //   breakdowns,
  // } = usePageConfiguration();
  // const { tabState: breakdownTabState } = useTabState("breakdown");
  // const { isBreakdownTab } = useActiveTabState();

  // const { benchmarkBreakdowns, benchmarkFilters } = useMemo(() => {
  //   let benchmarkFilters = [];

  //   for (const filter of filters) {
  //     for (const value of filter.values) {
  //       benchmarkFilters.push({ breakdown: filter.key, value });
  //     }
  //   }

  //   if (!isBreakdownTab && isSummaryRow) {
  //     for (const row of breakdownTabState.proposedFiltersState
  //       .inclusionAtomicities) {
  //       try {
  //         for (const atomicity of JSON.parse(row.atomicity)) {
  //           for (const [breakdown, value] of Object.entries(atomicity)) {
  //             benchmarkFilters.push({ breakdown, value: value as string });
  //           }
  //         }
  //         // eslint-disable-next-line no-empty
  //       } catch {}
  //     }
  //   }

  //   if (!row) {
  //     return { benchmarkBreakdowns: null, benchmarkFilters };
  //   }

  //   if (row.key === "default") {
  //     return { benchmarkBreakdowns: null, benchmarkFilters };
  //   }

  //   let benchmarkBreakdowns: Record<string, string>[] = [];

  //   if (breakdowns && breakdowns.length > 0) {
  //     for (const breakdown of breakdowns) {
  //       benchmarkBreakdowns.push({
  //         [breakdown.key]: row.rowMetadata.dimensions[breakdown.key],
  //       });
  //     }
  //   } else {
  //     benchmarkBreakdowns.push({
  //       "Platform (Northbeam)":
  //         row.rowMetadata.dimensions["Platform (Northbeam)"],
  //     });
  //   }

  //   let parsedRowKey;

  //   try {
  //     parsedRowKey = JSON.parse(row.key);
  //     // eslint-disable-next-line no-empty
  //   } catch {}

  //   if (Array.isArray(parsedRowKey)) {
  //     benchmarkBreakdowns = parsedRowKey;
  //   } else {
  //     benchmarkFilters = [];
  //   }

  //   return { benchmarkBreakdowns, benchmarkFilters };
  // }, [
  //   row?.key,
  //   row?.rowMetadata,
  //   breakdowns,
  //   filters,
  //   breakdownTabState,
  //   isSummaryRow,
  // ]);

  // const universalBenchmark = useUniversalBenchmarks({
  //   level:
  //     (row?.rowMetadata.tab === "breakdown"
  //       ? "campaign"
  //       : row?.rowMetadata.tab) ?? "campaign",
  //   attributionModel,
  //   attributionWindow,
  //   accountingMode,
  //   breakdowns: benchmarkBreakdowns,
  //   filters: benchmarkFilters,
  //   metric: columnDef.metric
  //     ? {
  //         id: columnDef.metric.metadata.baseId,
  //         isLtv: columnDef.metric.metadata.isLtv,
  //       }
  //     : undefined,
  // });

  // const benchmarkKpi = useMemo(() => {
  //   if (!row) {
  //     return null;
  //   }

  //   if (!universalBenchmark) {
  //     return null;
  //   }

  //   if (universalBenchmark.value === null) {
  //     return null;
  //   }

  //   if (!columnDef.metric) {
  //     return null;
  //   }

  //   const spendValue = row.export?.["spend"];

  //   if (!spendValue) {
  //     return null;
  //   }

  //   const metric = columnDef.metric;

  //   return {
  //     name:
  //       metric.name ??
  //       metric.metadata.name ??
  //       metric.spec?.name ??
  //       metric.metadata.salesTableMetricId,
  //     current: row.export?.[columnDef.id],
  //     target: universalBenchmark.value,
  //     format: metric.format,
  //     positiveTrend: metric.isPositiveChangeGood ? "up" : "down",
  //   } as BenchmarkIndicatorRow;
  // }, [
  //   row,
  //   columnDef.metric,
  //   columnDef.id,
  //   user.currencies.currentCurrency,
  //   universalBenchmark,
  // ]);

  return (
    <div className="h-full px-2 flex items-center">
      {/* {canShowMiniGraph && (
        <div className="h-8 w-16 mr-2 ">
          <MetricMiniGraph row={row} columnDef={columnDef} />
        </div>
      )} */}
      {/* {isBenchmark && !columnDef.loading && (
        <div
          className={clsx("font-mono font-light rounded-xl px-2 py-1", {
            "text-alien+2 bg-alien-2":
              benchmark?.percentDisplay !== "0.0%" &&
              (isPositiveChangeGood
                ? (benchmark?.value ?? 0) > 0
                : (benchmark?.value ?? 0) < 0),
            "text-mars+2 bg-mars-2":
              benchmark?.percentDisplay !== "0.0%" &&
              (isPositiveChangeGood
                ? (benchmark?.value ?? 0) < 0
                : (benchmark?.value ?? 0) > 0),
            "text-interstellar-1 bg-gray-1":
              benchmark?.percentDisplay === "0.0%",
          })}
        >
          {benchmark?.percentDisplay && benchmark.percentDisplay !== "0.0%" && (
            <i
              className={clsx("fa-regular fa-sharp text-[0.7rem] mr-1.5", {
                "fa-arrow-up": (benchmark?.value ?? 0) >= 0,
                "fa-arrow-down": (benchmark?.value ?? 0) < 0,
              })}
            ></i>
          )}
          {benchmark?.percentDisplay ?? "—%"}
        </div>
      )} */}
      {/* {universalBenchmark?.status === "loading" && (
        <Spinner colorClassname="w-3 h-3 text-cosmic text-xxs" />
      )} */}
      {/* {benchmarkKpi && (
        <UniversalBenchmarksIndicator
          benchmarkItemName={row?.rowMetadata?.naming?.name}
          benchmarkIndicatorRows={[benchmarkKpi]}
        />
      )} */}
      <div className="text-right text-xs font-mono flex-1 truncate">
        <div className="font-light truncate">
          {formatting.formatMetric(actualValue, metric.format, {
            code: user.currencies.currentCurrency,
          })}
        </div>
        {row.comparisonMetrics && (
          <ChangeFractionDisplay
            value={changeFraction}
            isPositiveChangeGood={metric.positiveTrend === "up"}
          />
        )}
      </div>
    </div>
  );
};
